import React from "react";
import "./viewPopupWrapper.css"; // Import the CSS file for styling
import { ReactComponent as CloseIcon } from "../../assets/icons/close-icon.svg";

const ViewPopupWrapper = ({ isOpen, onClose, title, columns, rows }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <p className="view-title">{title}</p>
          <button className="close-button" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-body">
          <div
            className="grid-container"
            style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
          >
            {rows.map((row, rowIndex) => (
              <div key={rowIndex} className="view-grid-row">
                {row.map((cell, cellIndex) => (
                  <div
                    key={cellIndex}
                    className="grid-cell"
                    style={{
                      gridColumn: `span ${cell.cols || 1}`,
                      textAlign: cell.alignment || "left",
                      borderBottom: cell.isLastRow ? "none" : "1px dashed #ccc",
                    }}
                  >
                    <p className="cell-title">{cell.title}</p>
                    <p className="cell-value"> {cell.value}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPopupWrapper;
